import styled from 'styled-components';
import colors from 'styles/colors';
import { Card } from 'semantic-ui-react';

export const StyledVehicleModalCard = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 56px;
  padding-left: 25px;
  border: 1px solid ${colors.fleetOffGray};
  border-radius: 3px;
  background-color: rgba(218, 222, 230, 0.2);
`;

export const StyledVinNumber = styled.div`
  display: flex;
  align-items: center;
  margin-right: auto;
  font-size: 16px;
  font-weight: bold;

  svg {
    margin-right: 7px;
  }
`;

export const StyledText = styled.div`
  display: flex;
  align-items: center;
  margin-right: auto;
  font-size: 14px;
  font-weight: 600;

  svg {
    margin-right: 5px;
  }
`;

export const ArrowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 9px 126px;
`;

export const StyledRentalDetailsCard = styled(Card)`
  margin-top: 16px !important;
  box-shadow: 0 0 0 1px ${colors.fleetOffGray}, 0 2px 6px 0 rgba(0, 0, 0, 0.08) !important;

  .ui.one.column.grid {
    margin: 0 !important;
    padding: 19px 14px 15px 14px !important;
  }

  .content {
    margin: 0 !important;
    padding: 0 !important;
  }

  .row {
    padding: 0 !important;
  }
`;
